var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLostBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 534,
    height: 288,
    viewBox: "0 0 534 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533.275 254.596V32.4426C533.275 14.5358 518.705 0.0195313 500.732 0.0195313L33.0715 0.0195313C15.0983 0.0195313 0.528076 14.5358 0.528076 32.4426V254.596C0.528076 272.503 15.0983 287.02 33.0715 287.02L500.732 287.02C518.705 287.02 533.275 272.503 533.275 254.596Z",
    fill: "#BEC2DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M529.875 254.596V32.4425C529.875 16.4055 516.827 3.40503 500.73 3.40503L33.0699 3.40503C16.9734 3.40503 3.92468 16.4055 3.92468 32.4425V254.596C3.92468 270.633 16.9734 283.634 33.0699 283.634L500.73 283.634C516.827 283.634 529.875 270.633 529.875 254.596Z",
    fill: "#FDF6FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M500.741 11.3042H33.0808C21.3635 11.3042 11.8647 20.7678 11.8647 32.4418V254.596C11.8647 266.27 21.3635 275.733 33.0808 275.733H500.741C512.458 275.733 521.957 266.27 521.957 254.596V32.4418C521.957 20.7678 512.458 11.3042 500.741 11.3042Z",
    fill: "#7E87BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512.885 254.597V32.443C512.885 25.7552 507.443 20.3337 500.731 20.3337L33.0702 20.3337C26.3576 20.3337 20.916 25.7552 20.916 32.443V254.597C20.916 261.285 26.3576 266.706 33.0702 266.706H500.731C507.443 266.706 512.885 261.285 512.885 254.597Z",
    fill: "#BEC2DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLostBoard);
export default __webpack_public_path__ + "static/media/LostBoard.1117725c1e31778c79e5.svg";
export { ForwardRef as ReactComponent };